<template>
  <div class="d-flex align-center ga-2">
    <v-btn
      variant="outlined"
      height="36"
      rounded="lg"
      class="download-btn"
      :loading="csvDownloadLoading"
      :disabled="libraryLoading || csvDownloadLoading || hasNoResults"
      @click="handleDownloadCsv"
    >
      <v-icon
        icon="$tray-arrow-down"
        class="mr-2"
        size="small"
      />
      Download CSV
    </v-btn>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useApprovalsDashboardStore } from '@/stores/jobProfiles/approvalsDashboard';
import { useTracking } from '@/stores/tracking/tracking';

defineProps({
  libraryLoading: { type: Boolean, default: false },
});

const route = useRoute();

const {
  flows,
  csvDownloadLoading,
} = storeToRefs(useApprovalsDashboardStore());
const { downloadCsv } = useApprovalsDashboardStore();

const hasNoResults = computed(() => !flows.value?.length);

const handleDownloadCsv = () => {
  useTracking().approvalLibDownloadedCsv();

  downloadCsv(route.query);
};
</script>

<style lang="less" scoped>
.download-btn {
  border: 1px solid @stroke-default;
  color: @text-dark;
  background: @white;
}
</style>
